import React from 'react';
import '../css/footer.css';
const Copyright = ({ title, logoUrl }) => {
    return (
        <div className={"copyright"}>
            {logoUrl && (
                <img src={logoUrl} className={"logo-custom"} alt="Logo" />
            )}
            <p>{title}</p>
        </div>
    );
};

export default Copyright;
